import React from 'react';

import { Button } from '@wwe-portal/ui/components/button';

export const RedeemCode = ({
  onCalculatorClick,
  redeemCodeClick,
  calculatorButtonContent,
}: {
  calculatorButtonContent: React.ReactNode;
  redeemCodeClick: () => void;
  onCalculatorClick: () => void;
}) => {
  return (
    <div className="flex h-8 items-center gap-2">
      <Button
        className="text-2xs w-0 min-w-[140px] flex-1"
        onClick={redeemCodeClick}
        variant="green"
      >
        Redeem Code
      </Button>
      <Button
        className="text-2xs w-0 min-w-[140px] flex-1 md:w-[180px] md:min-w-[180px]"
        onClick={onCalculatorClick}
        variant="blue"
      >
        {calculatorButtonContent}
      </Button>
    </div>
  );
};
